export default {
  credit: {
    detail: '详情',
    detailTitle: '积分流水详情',
    transId: '流水ID',
    transIdPlaceholder: '请输入流水ID',
    bizId: '业务ID',
    bizIdPlaceholder: '请输入业务ID',
    bizType: '业务类型',
    bizTypePlaceholder: '请输入业务类型',
    search: '查询',
    reset: '重置',
    ruleName: '规则名称',
    skuType: '商品类型',
    skuPrice: '商品价格',
    skuQuantity: '商品数量',
    changeDirection: '变动类型',
    changeAmount: '变动金额',
    balanceAfter: '变动后余额',
    changeTime: '变动时间',
    remark: '描述',
    increase: '增加',
    decrease: '减少',
    getBalanceFailed: '获取积分余额失败',
    copied: '已复制',
  },
};
